import { FINANCIAL_SUMMARY_RECEIVED, FINANCIAL_SUMMARY_UNLOADED } from './types'

export default function summary(state = {}, action = {}){
  switch (action.type) {
    case FINANCIAL_SUMMARY_RECEIVED:
      return action.data
    case FINANCIAL_SUMMARY_UNLOADED:
      return {}
    default:
      return state;
  }
}
